import { render, staticRenderFns } from "./ContentStatic.vue?vue&type=template&id=ae9b973e&scoped=true&"
import script from "./ContentStatic.vue?vue&type=script&lang=js&"
export * from "./ContentStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9b973e",
  null
  
)

export default component.exports